export default function(o, label, click, icon, iconRight, noHoverSound){

  var isActive = false

  // o.sounds.tick.sound.volume = 0.05

  var setIcon = function(newIcon){

    if(icon){
      var newIconDiv = getIcon(newIcon)
      iconDiv.replaceWith(newIconDiv)
      iconDiv = newIconDiv
      if(isActive){
        iconDiv
        .find('*')
        .attr({fill: o.colors.red})
      } else {
        iconDiv
        .find('*')
        .attr({fill: o.colors.yellow})
      }

    }

  }

  var setLabel = function(newLabel){
    labelDiv.html(newLabel)
  }

  var getIcon = function(newIcon){

    var newIconDiv =
      $('<div>')
      .append(
        o.svgs[newIcon].svg
        .clone()
        .css({
          width: '1em',
          height: '1em',  
        })
      )
      .css({
        flex: '0 0 auto',
        width: '1em',
        height: '1em',  
        filter: 'drop-shadow(rgba(0, 0, 0, 0.5) 0px 0.15em 0.15em)',
        marginTop: '-0.15em',
      })

    if(iconRight){
      newIconDiv.css({
        marginLeft: '0.1rem',
      })
    } else {
      newIconDiv.css({
        marginRight: '0.1rem',
      })
    }

    return newIconDiv

  }

  if(icon){
    var iconDiv = getIcon(icon)
  }

  var labelDiv =
    $('<div>')
    .css({
      flex: '1 1 auto',
      color: o.colors.red,
    })
    .html(label)

  var div =
    $('<div>')
    .css({
      margin: '0.3rem',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: o.colors.red,
      verticalAlign: 'bottom',
    })

  if(iconRight){
    div.css({
      flexDirection: 'row-reverse',
    })
  }

  if(icon){
    div.append(iconDiv)
    iconDiv
    .find('*')
    .attr({
      fill: o.colors.red,
    })
  }

  div.append(labelDiv)

  if(click){

    labelDiv
    .css({
      color: o.colors.yellow,
    })

    if(icon){
      iconDiv
      .find('*')
      .attr({
        fill: o.colors.yellow,
      })
    }

    div
    .css({
      cursor: "pointer",
    })
    .hover(
      function(){
        if(icon){
          iconDiv
          .find('*')
          .attr({fill: o.colors.red})
        }
        if(!noHoverSound){
          // o.util.soundTick(o)
        }
        labelDiv.css({color: o.colors.red})
        isActive = true
      },
      function(){
        if(icon){
          iconDiv
          .find('*')
          .attr({fill: o.colors.yellow})
        }
        labelDiv.css({color: o.colors.yellow})
        isActive = false
      },
    )
    .click(function(){
      // o.util.soundTick(o)
      click()
    })
  }

  div.setLabel = setLabel
  div.setIcon = setIcon

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/button/button.js